'use client'
import { TrackViewContext } from '@dragonpass/intl-unified-tracker'

import { ReactNode, useEffect, useMemo } from 'react'
import { Button, Result, Typography } from 'antd'
import { ErrorBoundary } from 'react-error-boundary'
// @ts-ignore
import { getLocale } from 'umi'
import { trackEvent } from '@/libs/functions/track'
const { Text, Paragraph } = Typography

const defaultLocale = 'en-US'

export const CustomErrBoundary = ({ error }: { error: any }) => {
  let currentLocale = defaultLocale
  currentLocale = getLocale ? getLocale() : defaultLocale

  const url = window.location.href.replace(
    (window.location.origin || '') + '/#',
    '',
  )

  return (
    <Result
      status="500"
      title={
        currentLocale === defaultLocale
          ? 'Whoops, something went wrong'
          : '出错了'
      }
      subTitle={
        currentLocale === defaultLocale
          ? 'This page failed to load, please try again later'
          : '页面加载失败，请稍后重试'
      }
      extra={
        <div>
          <Button type="primary" onClick={() => window.location.reload()}>
            {currentLocale === defaultLocale ? 'Reload' : '再试一次'}
          </Button>
          <Paragraph mark>
            {currentLocale === defaultLocale ? 'masterPageUrl' : '主页面地址'}：
            <Text copyable>{url}</Text>
          </Paragraph>
        </div>
      }
    />
  )
}

const SuccessLogWrapper = (props: any) => {
  useEffect(() => {
    try {
      console.log(
        '%c[Instana]%c reportEvent MASTER_RENDER_SUCCESS',
        'color: white; background-color: #1e88e5; padding: 2px 4px; border-radius: 3px;',
        'color: #1e88e5; font-weight: bold;',
      )
      // 主应用页面渲染成功
      trackEvent('MASTER_RENDER_SUCCESS', {
        meta: {
          url: window.location.href,
        },
      })
    } catch (err) {}
  }, [])

  return <>{props.children}</>
}

const logError = (error: Error, info: { componentStack: string }) => {
  console.log(error, info)
  // Do something with the error, e.g. log to an external API
  try {
    if (window.ineum) {
      console.error('[HTML Block Monitor] ❌ JavaScript error:', {
        errorMsg: error?.message,
        errorStack: error?.stack,
        errorType: error?.name,
        componentStack: info?.componentStack,
      })
      console.log(
        '%c[Instana]%c reportError RENDER_ERROR',
        'color: white; background-color: #1e88e5; padding: 2px 4px; border-radius: 3px;',
        'color: #1e88e5; font-weight: bold;',
        {
          url: window.location.href,
          errorMsg: error?.message,
          errorStack: error?.stack,
          errorType: error?.name,
          componentStack: info?.componentStack,
        },
      )
      ;(window as any).ineum('reportError', new Error('RENDER_ERROR'), {
        meta: {
          slaveAppName: 'master',
          position: 'master_layout',
          url: window.location.href,
          errorMsg: error?.message,
          errorStack: error?.stack,
          errorType: error?.name,
          componentStack: info?.componentStack,
        },
      })
    }
  } catch (err) {
    console.log('instana upload failed')
  }
}

export default function Layout(props: { children: ReactNode }) {
  const trackViewContextValue = useMemo(
    () => ({ tracker: window.dpTracker }),
    [window.dpTracker],
  )

  return (
    <ErrorBoundary FallbackComponent={CustomErrBoundary} onError={logError}>
      <SuccessLogWrapper>
        <TrackViewContext.Provider value={trackViewContextValue}>
          {props.children}
        </TrackViewContext.Provider>
      </SuccessLogWrapper>
    </ErrorBoundary>
  )
}
